import axios from 'axios'
import store from '@/store'

export default {
  getLogTimes (params) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/log-times', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          },
          params
        })
        .then(
          res => {
            store.dispatch('logTimes/setLogTimes', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createLogTime (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/log-times`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  updateLogTime (id, params) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/log-times/${id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removeLogTime (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/log-times/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  }
}
